// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewPopup_wrapper__-CtqW","popup":"PreviewPopup_popup__JYKaq","textareaWrapper":"PreviewPopup_textareaWrapper__6eqzW","inputs":"PreviewPopup_inputs__kKw9U"};